import { styled } from '@mui/material';
import { ReactComponent as ElamaIcon } from '../../../../../assets/images/elama.svg';
import { FormButton } from '../../../../UI';
import { IFormButtonProps } from '../../../../UI/FormButton';

export const Button = styled((props: IFormButtonProps) => (
  <FormButton startIcon={<ElamaIcon style={{ width: 24, height: 24 }} />} variant={'outlined'} {...props} />
))('');
